import { deserializePayloadContent } from '../../../chat-input/helpers';
import styles from './index.module.scss';

const SysText = ({
  children,
  textColor = 'gray',
  noStyle = false,
}: {
  children: React.ReactNode;
  textColor?: 'black' | 'gray';
  noStyle?: boolean;
}) => {
  const payload = useMemo(
    () =>
      typeof children === 'string' ? deserializePayloadContent(children) : children,
    [children]
  );

  return (
    <div
      className={cls(
        styles.sysText,
        noStyle ? styles.ellipsis : styles.textSysText,
        styles[textColor]
      )}
    >
      {payload}
    </div>
  );
};

export default SysText;
